import { useSelector } from 'react-redux';
import { CommentState } from '@/reducers/comment';

export default function useCommentList() {
  const commentList = useSelector((state: { comment: CommentState }) => state.comment.commentList);

  return commentList;
}
